
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Radio,
Group,
Cell,
Badge,
Drawer,
ButtonTab,
ButtonTabItem,
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Loading,
Actionsheet
},
data () {
return {
headerTitle: "首页"
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue